import { NgClass } from '@angular/common';
import { ChangeDetectionStrategy, Component, input, output } from '@angular/core';
import { SvgIconComponent, SvgIcons } from '@ngneat/svg-icon';

@Component({
  selector: 'app-icon-button',
  imports: [NgClass, SvgIconComponent],
  templateUrl: './icon-button.component.html',
  styleUrl: './icon-button.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class IconButtonComponent {
  public icon = input.required<SvgIcons>();
  public size = input<'small' | 'medium' | 'large'>('medium');
  public type = input<'primary' | 'secondary' | 'transparent'>('primary');
  public disabled = input(false);
  public clickEvent = output<MouseEvent>();

  public onClick(event: MouseEvent): void {
    this.clickEvent.emit(event);
  }
}
